export function formatNumber(value?: number): string {
  if (!value && value !== 0) return ''
  const values = value.toString().split('.')
  let newValue = values[0]
    .split('')
    .reverse()
    .reduce(function (acc, num, i) {
      return num + (num != '-' && i && !(i % 3) ? ',' : '') + acc
    }, '')

  if (values[1]) {
    newValue += '.'
    newValue += values[1]
  }

  return newValue
}
